import { Banner } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/pro-regular-svg-icons';

export const EditorialPreProductionBanner = () => {
  return (
    <Banner
      variant="attention"
      customIcon={<FontAwesomeIcon icon={faWarning} />}
      heading="Request Submission Updates"
      content="If any information on this page is missing or is unclear, you can request the author to update any fields requiring their input."
    />
  );
};
